var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-page"},[_c('TopBanner'),_c('div',{staticClass:"about-scroll-area"},[_c('div',{staticClass:"about-box"},[_c('div',{staticClass:"about-title"},[_vm._v("平台简介")]),_c('div',{staticClass:"about-content"},[_c('div',{staticClass:"agreement-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }